import { useLanguage } from '../../../context/LanguageContext';

export default function Partners() {
  const { t } = useLanguage();

  const partners = [
    {
      name: 'Ecotec ME',
      url: 'https://www.ecotec-me.com',
      logo: 'https://public.readdy.ai/ai/img_res/edited_c48216d2b5d8afb12a65a92031d4f778_8639f4f4.jpg',
    },
    {
      name: 'ITS Egypt',
      url: 'https://www.its-egypt.co',
      logo: 'https://public.readdy.ai/ai/img_res/a238b968-ec07-445f-a2cf-ab3a2a24ba4a.png',
    },
    {
      name: 'Polonizot',
      url: 'https://www.polonizot.pl',
      logo: 'https://public.readdy.ai/ai/img_res/f53f0400-02d2-4147-a760-4c4dd64ac5e9.png',
    },
    {
      name: 'MK Trade Hub',
      url: 'https://www.mktradehub.com',
      logo: 'https://public.readdy.ai/ai/img_res/edited_ec7eae785a1736aa59e69707df9cc456_a2300295.jpg',
    },
    {
      name: 'Lumenat',
      url: 'https://www.lumenat.io',
      logo: 'https://public.readdy.ai/ai/img_res/bd4e0cfa-8059-4ba0-9e50-fe5925e25302.png',
    },
  ];

  return (
    <section id="partners" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="w-16 h-0.5 bg-[#C9A961] mx-auto mb-6"></div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-[#1A2B4A] mb-6">
            {t('partners.heading')}
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('partners.description')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 md:gap-8 mb-12">
          {partners.map((partner, index) => (
            <a
              key={index}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center p-4 sm:p-5 md:p-6 bg-white rounded-lg transition-all duration-300 hover:shadow-lg border border-gray-100 hover:border-[#C9A961] cursor-pointer"
            >
              <div className="w-full h-14 sm:h-16 flex items-center justify-center">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain transition-all duration-300 opacity-70 group-hover:opacity-100"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}